import { FuseProviderConfig } from '@fuse/index';

export const FuseConfig: FuseProviderConfig = {
  fuse: {
    layout: 'dense',
    scheme: 'dark',
    screens: {
      sm: '600px',
      md: '960px',
      lg: '1280px',
      xl: '1440px',
    },
    theme: 'theme-brand',
    themes: [
      {
        id: 'theme-default',
        name: 'Default',
      },
      {
        id: 'theme-brand',
        name: 'Brand',
      },
    ],
  },
};
